// extracted by mini-css-extract-plugin
module.exports = {"button":"iconbutton_button__7J0Bw"};